import Avatar from "../components/Avatar";
import { useUser } from "../redux/user";

export default function UserAvatar({ className }) {
  // avatarUpdateCount used for rerender when there is update
  const { fbId, avatarId, id, avatarType, avatarUpdateCount } = useUser();

  return (
    <Avatar
      fbId={fbId}
      avatarId={avatarId}
      id={id}
      avatarType={avatarType}
      avatarUpdateCount={avatarUpdateCount}
      className={className}
    />
  );
}
